import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  Issuer,
  Cedear,
  Currency,
  Option,
  Horizon,
  MarketTab,
  RiskProfile,
  SettlementLimit,
  StocksPanel,
  WithdrawalPeriod,
  Sector,
  FundsCurrency,
  Instrument,
  UnderlyingAsset,
} from "../../pages/MarketPage/types";

const INSTRUMENT_DEFAULT = "STOCKS";

const queryParams = new URLSearchParams(location.search);
const instrumentQuery =
  (queryParams.get("instrument") as MarketTab) ?? INSTRUMENT_DEFAULT;

interface InitialState {
  tab: MarketTab;
  sectors: Sector[];
  filters: {
    stocksPanel: StocksPanel;
    bondIssuer: Issuer;
    currency: FundsCurrency;
    cedearTypes: (Cedear | "ALL")[];
    optionUnderlyingAsset: UnderlyingAsset;
    optionTypes: (Option | "ALL")[];
    settlement: SettlementLimit;
    currencies: (Currency | "ALL")[];
    sectors: (Sector | "ALL")[];
    withdrawalPeriods: (WithdrawalPeriod | "ALL")[];
    riskProfiles: (RiskProfile | "ALL")[];
    horizons: (Horizon | "ALL")[];
    offersOnly: "YES" | "NO";
    search: string;
    dualCurrencies: (FundsCurrency | "ALL")[];
  };
  isFavoritesModalOpen?: boolean;
  favoritesInstrumentType?: Instrument | "FUNDS";
}

const initialState: InitialState = {
  tab: instrumentQuery,
  sectors: [],
  filters: {
    stocksPanel: "LEADER",
    bondIssuer: "SOVEREIGN",
    cedearTypes: ["ALL"],
    currency: "ARS",
    optionUnderlyingAsset: "STOCKS",
    optionTypes: ["ALL"],
    settlement: "T1",
    currencies: ["ALL"],
    sectors: ["ALL"],
    withdrawalPeriods: ["ALL"],
    riskProfiles: ["ALL"],
    horizons: ["ALL"],
    offersOnly: "YES",
    search: "",
    dualCurrencies: ["ALL"],
  },
  isFavoritesModalOpen: false,
  favoritesInstrumentType: undefined,
};

const marketSlice = createSlice({
  name: "market",
  initialState,
  reducers: {
    updateData: (state, action: PayloadAction<Partial<InitialState>>) => {
      return { ...state, ...action.payload };
    },
    updateTab: (state, action: PayloadAction<MarketTab>) => {
      state.tab = action.payload;
    },
    updateFilter: (
      state,
      action: PayloadAction<Partial<InitialState["filters"]>>,
    ) => {
      return { ...state, filters: { ...state.filters, ...action.payload } };
    },
    resetFilters: (state) => {
      state.filters = {
        stocksPanel: "LEADER",
        bondIssuer: "SOVEREIGN",
        cedearTypes: ["ALL"],
        currency: "ARS",
        optionUnderlyingAsset: "STOCKS",
        optionTypes: ["ALL"],
        settlement: "T1",
        currencies: ["ALL"],
        sectors: ["ALL"],
        withdrawalPeriods: ["ALL"],
        riskProfiles: ["ALL"],
        horizons: ["ALL"],
        offersOnly: "YES",
        search: "",
        dualCurrencies: ["ALL"],
      };
    },
    reset: () => initialState,
    openFavoriteModal: (state) => {
      state.isFavoritesModalOpen = true;
    },
  },
});

export type InitialMarketState = InitialState; // HACK

export const {
  updateData,
  updateTab,
  updateFilter,
  resetFilters,
  reset,
  openFavoriteModal,
} = marketSlice.actions;

export default marketSlice.reducer;
